module.exports = __webpack_public_path__ + "static/Kelly-Portrait-mobile-b8940cffbf488689af935194253f9308.jpg";